module.exports = __webpack_public_path__ + "img/WriteIcon.1dbdf34a.svg";